module.exports = __webpack_public_path__ + "img/paypal.a807a6f2.svg";